import { useEffect, useCallback, useRef } from "react";
import { useBeforeUnload, useBlocker } from "react-router-dom";

const pages = ["/prijava", "/studentska-prijava", "/uspesno-poslano/podjetje", "/uspesno-poslano/student"];

export default function FormPrompt({ hasUnsavedChanges, dirtyFields }) {
  const isDirtyAlt = !!Object.keys(dirtyFields).length;
  const onLocationChange = useCallback(
    ({ nextLocation }) => {
      if (!pages.includes(nextLocation.pathname) && hasUnsavedChanges) {
        if (isDirtyAlt) {
          return window.confirm(
            "You have unsaved changes, are you sure you want to leave?"
          );
        }
        return false;
      }
    },
    [isDirtyAlt, hasUnsavedChanges]
  );

  usePrompt(onLocationChange, isDirtyAlt);
  useBeforeUnload(
    useCallback(
      (event) => {
        if (isDirtyAlt) {
          event.preventDefault();
          event.returnValue = "";
        }
      },
      [isDirtyAlt]
    ),
    { capture: true }
  );

  return null;
}

function usePrompt(onLocationChange, hasUnsavedChanges) {
  const blocker = useBlocker(hasUnsavedChanges ? onLocationChange : false);
  const prevState = useRef(blocker.state);

  useEffect(() => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
    prevState.current = blocker.state;
  }, [blocker]);
}
